import {ITopic} from "../../Interfaces/Topic";
import {useTopicsContext} from "./TopicsContext.hook";

export interface ITopicsContextState {
    loaded: boolean,
    list: Array<ITopic>,
}

export type ITopicsContext = ReturnType<typeof useTopicsContext>;

/////////////////////////////////////////////////////// REDUCER ///////////////////////////////////////////////////////

export enum TopicsContextDispatchMessageType {
    SetList, SetLoaded, AddUpdateTopic, DeleteTopic
}

type SetList = {
    type: TopicsContextDispatchMessageType.SetList,
    list: Array<ITopic>
};

type SetLoaded = {
    type: TopicsContextDispatchMessageType.SetLoaded,
    value: boolean,
}

type AddUpdateTopic = {
    type: TopicsContextDispatchMessageType.AddUpdateTopic,
    topic: ITopic
}

type DeleteTopic = {
    type: TopicsContextDispatchMessageType.DeleteTopic,
    id: string,
}

export type TopicsContextDispatchMessage =
    SetList |
    SetLoaded |
    AddUpdateTopic |
    DeleteTopic
